// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabStyles {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.01em;
  text-align: left;
  padding: 16px;
}

.white-color {
  color: white !important;
}

.mobileTabsStyles {
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.01em;
  text-align: left;
  padding: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/StudentDashboard/ActivityTabsHeader/styles.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;AACF","sourcesContent":[".tabStyles {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  letter-spacing: -0.01em;\n  text-align: left;\n  padding: 16px;\n}\n\n.white-color {\n  color: white !important;\n}\n\n.mobileTabsStyles {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 20px;\n  letter-spacing: -0.01em;\n  text-align: left;\n  padding: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
